import { render } from "./BurgerMenu.vue?vue&type=template&id=9dbbe8c6"
import script from "./BurgerMenu.vue?vue&type=script&lang=js"
export * from "./BurgerMenu.vue?vue&type=script&lang=js"

import "./BurgerMenu.vue?vue&type=style&index=0&id=9dbbe8c6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__